import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./style.module.css";
import { useTheme } from "../../../context/themeContext";
import BasicTabs from "./components/tabs";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { node_server } from "../../../constants";
import { updateShoutoutsData } from "../../../store/slices/profile/shoutoutsSlice";
import LoadingButton from "../../../components/loading/button";
import { setIsButtonLoading } from "../../../store/slices/loadingSlice";

const ShoutOuts = () => {
  const { theme } = useTheme();
  const user = useSelector((state) => state.user.value);
  const {
    data: { receivedShoutouts, givenShoutouts },
  } = useSelector((state) => state.shoutouts);
  const dispatch = useDispatch();
  const { buttonLoading } = useSelector((state) => state.isLoading);

  useEffect(() => {
    if (!user) return;
    const fetchShoutOutsData = async () => {
      dispatch(setIsButtonLoading(true));
      const { data, error } = await axios.get(
        `${node_server}/api/shoutouts`,
        { withCredentials: true }
      );

      if (error) console.log(error);
      if (data) {
        dispatch(
          updateShoutoutsData({
            receivedShoutouts: data.receivedShoutouts,
            givenShoutouts: data.givenShoutouts,
          })
        );
      }
      dispatch(setIsButtonLoading(false));
    };

    if (receivedShoutouts === null || givenShoutouts === null) {
      fetchShoutOutsData();
    }
  }, [user]);

  if (buttonLoading) {
    return (
      <Box className={styles.loading}>
        <LoadingButton />
      </Box>
    );
  }

  return (
    <Box
      className={styles.newClassName}
      sx={{ backgroundColor: theme.palette.lightgrey.lightgrey600 }}
    >
      <Box className={styles.content}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.5rem",
            fontWeight: "500",
            textAlign: "centerd",
            display: "flex",
            alignSelf: "stretch",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.darkgrey.darkgrey600,
          }}
        >
          Shout Outs
        </Typography>
        <BasicTabs />
      </Box>
    </Box>
  );
};

export default ShoutOuts;
